<label class="toggle" [for]="inputId">
  <input
    [attr.aria-labelledby]="label ? null : inputId"
    [id]="inputId"
    type="checkbox"
    [checked]="active"
    [disabled]="disabled"
    (change)="toggle()"
  />
  <span class="slider"></span>
  <span class="label" [innerHTML]="label"></span>
</label>
